import { QueryClientProvider } from "@tanstack/react-query";
import { type ComponentPropsWithoutRef, Suspense, lazy } from "react";
import { queryClient } from "../../query";

const DeploymentCreateFormInner = lazy(() => import("./component"));

export default function DeploymentCreateForm(
  props: ComponentPropsWithoutRef<typeof DeploymentCreateFormInner>
) {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div>Loading...</div>}>
        <DeploymentCreateFormInner {...props} />
      </Suspense>
    </QueryClientProvider>
  );
}
